import { Decoration } from '@atlaskit/editor-prosemirror/view';

export const createTelepointerElement = (label: string) => {
	const telepointerElement = document.createElement('span');
	telepointerElement.setAttribute('data-testid', `ai-in-editor-telepointer-widget`);
	telepointerElement.className = `ai-in-editor-telepointer`;

	const telepointerLabel = document.createElement('span');
	telepointerLabel.setAttribute('data-testid', `ai-in-editor-telepointer-widget-label`);
	telepointerLabel.className = `ai-in-editor-telepointer-label`;
	telepointerLabel.append(label);
	telepointerElement.appendChild(telepointerLabel);

	return telepointerElement;
};

export const createTelepointerWidget = (position: number, element: HTMLElement) => {
	return Decoration.widget(position, element, {
		side: 0,
		key: 'inEditorAIContentDecoration',
	});
};
